import { Stack, Typography } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { Plus } from '@phosphor-icons/react';
import { t } from 'i18next';

import { TextHighlighter } from 'core/elements';
import { IAutocompleteOption } from 'core/types';
import { Color, Direction, Level } from 'theme/enums';

import { LOADING_LABEL } from './constants';
import { CreateNewOptionValueWrapper } from './style';

export const getOptions = (options = [], loading = false) => {
  const withLoading = loading ? [{ label: LOADING_LABEL, value: -1, isLoading: true }] : [];

  return [...options, ...withLoading];
};

export const defaultRenderOptions = (
  option: unknown,
  getLabel: (option: unknown) => string,
  inputValue?: string
) => (
  <Typography level="inherit">
    <TextHighlighter level="inherit" text={getLabel(option)} highlight={inputValue} />
  </Typography>
);

export const defaultRenderNewOption = (
  option: IAutocompleteOption,
  label?: string,
  options: {
    titleSx?: SxProps;
  } = {}
) => (
  <Stack gap={0.5} direction={Direction.ROW}>
    {label && <Typography level={Level.TITLE_SM}>{label}</Typography>}

    <CreateNewOptionValueWrapper level={Level.TITLE_SM} color={Color.PRIMARY} sx={options?.titleSx}>
      <Plus />
      {t('labelAddOption', { option: option?.title })}
    </CreateNewOptionValueWrapper>
  </Stack>
);
